import React, { useState, useEffect } from 'react';
import { useParams, Link as RouterLink, useHistory } from 'react-router-dom';
import { useDispatch, RootStateOrAny, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { selectSitesBySn, selectSitesState } from '../../redux/slices/sitesSlice';
import { selectContactsState } from '../../redux/slices/contactsSlice';
import { fetchConcentrateursForSiteSn, selectConcentrateursBySiteSn, selectConcentrateursState } from '../../redux/slices/concentrateursSlice';
import /*equipementsSlice, */{ fetchEquipements, selectEquipementsState, selectEquipementsBySiteSn, fetchEquipementsForSiteSn, selectEquipementsStateSn, fetchEquipementsBySiteId } from '../../redux/slices/equipementsSlice';
import GrafanaIcon from '../../svg/grafana-icon.png';
import SitesTableDetail from './SitesTableDetail';
import SiteForm from './SiteForm';
import SitesMenu from './SitesMenu';
import SiteActionCard from './SitesActionCard';
import ContactCard from './ContactsCard';
import ContactsCard from './ContactsCard';
import SitesListMobile from './SitesListMobile';
import sortSites from '../../utils/sortSites';
import LoadingSpinner from '../../components/LoadingSpinner';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import InfoText from '../../components/InfoText';
import FormDialog from '../../components/FormDialog';
import AddIcon from '@material-ui/icons/Add';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  useMediaQuery,
  Link,
  Paper,
  Button,
} from '@material-ui/core';
import { useTableStyles } from '../../styles/muiStyles';
import { useTheme } from '@material-ui/core/styles';
import { useMainPageStyles } from '../../styles/muiStyles';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { SiteState } from '../../redux/types';
import { EEXIST } from 'constants';
import { fetchPostes } from '../../redux/slices/postesSlice';
import { fetchRooms } from '../../redux/slices/roomsSlice';
import { autoLogin, selectAuthState } from '../../redux/slices/authSlice';
import ConcModForm from './ConcModForm';
import ConcentrateurInstrumView from './ConcentrateurInstrumView';
import { fetchQuestionsInstrums } from '../../redux/slices/questionsInstrumSlice';
import { fetchVoiesBySitesSn } from '../../redux/slices/voie2mesuresSlice';

interface ParamTypes {
    siteSn: string;
    siteId: string;
}

const SiteSnPage = (/*{ sites }*/) => {
  const { siteSn, siteId } = useParams<ParamTypes>();
  //const sites = useDispatch;
  const classes = useMainPageStyles();
  const MoreClasses = useTableStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const history = useHistory();
  const dispatch = useDispatch();
  /*const equipements = useSelector((state: RootState) =>
    selectEquipementsBySiteSn(state, siteSn)
  );*/
  const { user } = useSelector(selectAuthState);  
  const shortSnSite = siteSn.replace("10","")
//  fetchEquipementsForSiteSn(siteSn);
  
  const { sites /*, fetchStatus, fetchError, sortBy*/ } = useSelector(
    selectSitesState
  );
  const { contacts } = useSelector(
    selectContactsState
  );
  const { concentrateurs } = useSelector(
    selectConcentrateursState
  );
  dispatch(fetchEquipementsBySiteId(siteId))
  dispatch(fetchRooms())
  dispatch(fetchQuestionsInstrums())
  dispatch(fetchVoiesBySitesSn(siteSn))
/*  dispatch(fetchEquipementsBySiteId(siteId))
  const { equipements, fetchLoading, fetchError, sortBy } = useSelector(
    selectEquipementsState
  );
  useEffect(() => {
    if (!equipements) {
      dispatch(autoLogin());
//        dispatch(fetchEquipementsForSiteSn(siteSn));    // CAUSE jwt malformed error ?
//      dispatch(fetchConcentrateursForSiteSn(siteSn));    // CAUSE jwt malformed error ?
      dispatch(fetchEquipementsBySiteId(siteId)) }
}, []);
*/
  console.log("siteId: "+siteId);
  sites.filter((c)=>c.sn_site === siteSn).map((s)=> {
    console.log("Lgmt SN: "+s.sn_site+" ConcSN: "+s.concentrateur[0]?.hardSn)
  })
  const nbConc = sites.filter((c)=>Number(c.sn_site) === Number(siteSn)).filter((s)=>s.concentrateur?.length > 0).length
  const nbConc2 = concentrateurs.filter((c)=>Number(c.site_sn) === Number(siteSn)).length
  console.log("nbConcFromSites: "+nbConc+" / nbConcFromCONCz: "+nbConc2)
  const [filterValue, setFilterValue] = useState('');

  const filteredSortedSites = sites;
  const filteredSortedContacts = contacts;
  
  const filteredSites = sites.filter(site => {return Number(site.sn_site) == Number(siteSn)});
  console.log("FILTERED" + filteredSites.length);
//  console.log("...ID yé tu: "+filteredSites.map((s) => s.id));
  const siteID = filteredSites.map((s) => s.id);
  const sitesDataToDisplay = () => {
  /*  if (fetchLoading === true) {
      return (
        <LoadingSpinner
          marginTop={isMobile ? '4em' : '9em'}
          size={isMobile ? 60 : 80}
        />
      );
    } else {*/
      return (
        <div className={classes.sitesListTable}>
          <SitesTableDetail siteId={siteId} sites={filteredSites} siteSn={siteSn}/>
        </div>
      );
//    }
  };
  if(nbConc === 0) {
    return (
      <div className={classes.root}>
        <Paper className={classes.headerPaper}>
          <AssignmentIcon
            fontSize="large"
            color="primary"
            className={classes.headerIcon}
          />
          <div>
            <Typography variant={isMobile ? 'h6' : 'h5'} color="secondary">
              Site #<b>{siteSn}</b> : Ajoutez un concentrateur et actualisez la page SVP
            </Typography>
            <div>
              {/*<Button variant="outlined" className={MoreClasses.buttonsSiteSnP}/*onClick={}/>
                <Link
                    component={RouterLink}
                    to={`/site/${siteSn}/modify`}
                    color="secondary"
                  >Modifier le site
                  </Link>
              </Button>*/}
              {/* fetchLoading === true ?
              (<LoadingSpinner
                marginTop={isMobile ? '4em' : '9em'}
                size={isMobile ? 60 : 80}
              />)
              : (*/
                <ConcModForm
                  editMode="AddConc"
                  currentConcentrateurs={undefined}
                  currentModules={undefined}
                  siteId={siteId}
                />//)*/
                }
            </div>
          </div>
        </Paper>
      </div> );
  } else {
    if(sites.filter(site => {return site.sn_site == siteSn}).filter((s) => s.concentrateur.length > 0)
      .find((s)=> s.concentrateur.find((c)=>c.modules.length > 0))) {
        return (
          <div className={classes.root}>
            <Paper className={classes.headerPaper}>
              <AssignmentIcon
                fontSize="large"
                color="primary"
                className={classes.headerIcon}
              />
              <div>
                <Typography variant={isMobile ? 'h6' : 'h5'} color="secondary">
                  Site #<b>{siteSn}</b>
                </Typography>
                <Typography
                  variant={isMobile ? 'caption' : 'subtitle1'}
                  color="secondary"
                >
                  Liste des concentrateurs associés au site, actifs et passés. Le concentrateur le plus récemment utilisé est en fin de liste.
                </Typography>
                <div>
                  {/* fetchLoading === true ?
                  (<LoadingSpinner
                    marginTop={isMobile ? '4em' : '9em'}
                    size={isMobile ? 60 : 80}
                  />)
                  : (*/<Button variant="contained" className={MoreClasses.buttonsSiteSnP} 
                    onClick={() => history.push(`/site/${siteSn}/${siteId}/equipements`)}>
                    <Link style={{color: 'rgba(0, 0, 0, 0.87)'}}
                        component={RouterLink}
                        to={`/site/${siteSn}/${siteId}/equipements`/*`/sites/${p.id}`*/}
                        color="secondary"
                      >Voir les équipements
                      </Link>
                  </Button>//)
                  }
                  <Button variant="contained" className={MoreClasses.buttonsSiteSnP} 
                    //onClick={() => history.push(`/site/${siteSn}/${siteId}/equipements`)}
                    >
                    <a style={{color: 'rgba(0, 0, 0, 0.87)', textDecoration: 'none'}} href={"https://visu.enertech.fr/d/_9Gr38AVz/par-logement?orgId=57&var-log=log_"+shortSnSite} target="_blank"
                      ><img style={{top: '0.15rem', position: 'relative'}} src={GrafanaIcon} width="25"/>&nbsp;<span style={{bottom: '0.25rem', position: 'relative'}}>Voir dans Grafana</span>
                    </a>
                  </Button>
                  <Button variant="outlined" className={MoreClasses.buttonsSiteSnP}
                      component={RouterLink}
                      to={`/logement/${siteSn}/${siteId}`}
                    >
                    <EditOutlinedIcon style={{ marginRight: '10px' }} />
                    Gérer les infos logement
                  </Button>
                  {/*<Button variant="outlined" className={MoreClasses.buttonsSiteSnP}/*onClick={}/>
                    <Link
                        component={RouterLink}
                        to={`/contacts/${siteSn}`/*`/sites/${p.id}`/}
                        color="secondary"
                      >Voir les contacts
                      </Link>
                  </Button>*/}
                </div>
              </div>
            </Paper>
            <Paper className={classes.sitesPaper}>
              {sitesDataToDisplay()}
            </Paper>
          </div>
        ); 
    }
    else {
      return (
        <div className={classes.root}>
          <Paper className={classes.headerPaper}>
            <AssignmentIcon
              fontSize="large"
              color="primary"
              className={classes.headerIcon}
            />
            <div>
              <Typography variant={isMobile ? 'h6' : 'h5'} color="secondary">
                Site #<b>{siteSn}</b> : Ajoutez un module et actualisez la page SVP
              </Typography>
              <div>
                {/*<Button variant="outlined" className={MoreClasses.buttonsSiteSnP}/*onClick={}/>
                  <Link
                      component={RouterLink}
                      to={`/site/${siteSn}/modify`}
                      color="secondary"
                    >Modifier le site
                    </Link>
                </Button>*/}
                {/* fetchLoading === true ?
                (<LoadingSpinner
                  marginTop={isMobile ? '4em' : '9em'}
                  size={isMobile ? 60 : 80}
                />)
                : (*/
                  <ConcModForm
                    editMode="AddModule"
                    currentConcentrateurs={filteredSites.find((s)=>Number(s.id) === Number(siteId))?.concentrateur/*.map((c)=>String(c.hardSn))*/}
                    currentModules={undefined}
                    siteId={siteId}
                  />
                  //)
                  }
              </div>
            </div>
          </Paper>
        </div> );
    }
  }
/*  return (
    <ConcentrateurInstrumView sites={sites} siteId={siteId} siteSn={siteSn} />
  );*/
};

export default SiteSnPage;
